import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import {
  readStoredTenantConfig,
  isLocalDevHost,
  clearStoredTenantConfig,
  getPublicTenantConfig,
} from "../utils/tenantConfig";

const TenantNotFound = () => {
  const navigate = useNavigate();
  const cfg = readStoredTenantConfig();
  const message = cfg?.message || "No tenant for host";

  useEffect(() => {
    if (!isLocalDevHost()) return;
    clearStoredTenantConfig();
    getPublicTenantConfig().then((data) => {
      if (data?.result?.exists !== false) {
        navigate("/login", { replace: true });
      }
    });
  }, [navigate]);

  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-white font-sans text-gray-900 px-6">
      <div className="text-center max-w-md">
        <p className="text-7xl font-black text-gray-200 tracking-tight mb-2">
          404
        </p>
        <h1 className="text-2xl font-extrabold text-gray-900 mb-3">
          Workspace not found
        </h1>
        <p className="text-gray-600 text-[15px] leading-relaxed mb-8">
          {message}. This URL may be incorrect or your organization has not been
          set up for this address. Contact your administrator if you need help.
        </p>
        <div className="flex flex-col sm:flex-row gap-3 justify-center">
          <a
            href="https://www.kornivus.com/"
            target="_blank"
            rel="noopener noreferrer"
            className="w-full sm:w-auto border border-blue-600 text-blue-700 hover:bg-blue-50 py-3 px-8 rounded-xl font-bold text-[15px] transition-colors inline-flex items-center justify-center"
          >
            Visit Kornivus
          </a>
        </div>
      </div>
    </div>
  );
};

export default TenantNotFound;
